import path from 'node:path'
import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { applyAdminNamespaceToPath } from '@next-adapter/config/namespace/apply-admin-namespace-to-path.js'

export function resolveInstallableProjectPath(
  config: ResolvedBetterstartConfig,
  outputPath: string
): string {
  const namespacedOutputPath = applyAdminNamespaceToPath(
    outputPath,
    config.frameworkConfig.next.namespace
  )
  return path.posix.join(config.paths.admin.replace(/^\.\//, ''), namespacedOutputPath)
}
